/*
 * Resolución del tenantId EFECTIVO (la ficha PlatformTenantConfig_GT real) a partir del
 * user.tenantId.
 *
 * Un admin de Platform tiene user.tenantId con valor wildcard (scopeRef global del rol PLATFORM).
 * No existe ficha PlatformTenantConfig_GT para ese wildcard ni endpoint /tenants/wildcard/...
 * (responde 404). El contenedor que le corresponde es la plataforma misma (la ficha "platform"),
 * así que mapeamos el wildcard al tenantId "platform". Cualquier otro tenant pasa tal cual.
 *
 * Aplica a TODO endpoint /tenants/{tenantId}/... que el platform admin consume vía su propio
 * tenantId (branding, roles), porque todos resuelven contra la misma ficha PlatformTenantConfig_GT.
 * Verificado en rbac (platform-rbac-business): getForTenant('platform') resuelve la ficha 'platform'
 * (existe, status active, tablePrefix "Platform") → GET /tenants/platform/{branding,roles} → 200.
 *
 * Función pura, sin hooks, para reusarla en el BrandingProvider global, en el BrandingEditor
 * del tenant propio, en MyRoleAssignments, y donde sea que se use user.tenantId contra /tenants/.
 */
export const PLATFORM_CONTAINER_TENANT_ID = 'platform';

/** Mapea el wildcard '*' del platform admin a la ficha real 'platform'; el resto pasa tal cual. */
export function resolvePlatformContainerTenantId(tenantId: string | undefined): string | undefined {
    if (!tenantId) return tenantId;
    return tenantId === '*' ? PLATFORM_CONTAINER_TENANT_ID : tenantId;
}
